const state = {
  appHost: null,
  appSavitarna: false,
  appBaseApi: null,
  savitarnaKrepselisUrl: null,
  savitarnaHomeUrl: null,
  savitarnaBreadcrumbs: [],
}

// getters
const getters = {
  appHost: state => state.appHost,
  appSavitarna: state => state.appSavitarna,
  appBaseApi: state => state.appBaseApi,
  savitarnaKrepselisUrl: state => state.savitarnaKrepselisUrl,
  savitarnaHomeUrl: state => state.savitarnaHomeUrl,
  savitarnaBreadcrumbs: state => state.savitarnaBreadcrumbs,
}

// actions
const actions = {
  setAppHost({ commit, dispatch }, host) {
    const savitarna = host === process.env.VUE_APP_SAVITARNA_HOST
    // const savitarna = JSON.parse(sessionStorage.getItem('isSavitarna'))

    dispatch('appHost', host)
    dispatch('appSavitarna', savitarna)
    dispatch(
      'appBaseApi',
      savitarna
        ? process.env.VUE_APP_SAVITARNA_BASE_API
        : process.env.VUE_APP_BASE_API
    )
  },
  appHost({ commit }, payload) {
    commit('appHost', payload)
  },
  appSavitarna({ commit }, payload) {
    commit('appSavitarna', payload)
  },
  appBaseApi({ commit }, payload) {
    commit('appBaseApi', payload)
  },
  savitarnaKrepselisUrl({ commit }, payload) {
    commit('savitarnaKrepselisUrl', payload)
  },
  savitarnaHomeUrl({ commit }, payload) {
    commit('savitarnaHomeUrl', payload)
  },
  savitarnaBreadcrumbs({ commit }, payload) {
    commit('savitarnaBreadcrumbs', payload)
  },
}

// mutations
const mutations = {
  appHost(state, data) {
    state.appHost = data
  },
  appSavitarna(state, data) {
    state.appSavitarna = data
  },
  appBaseApi(state, data) {
    state.appBaseApi = data
  },
  savitarnaKrepselisUrl(state, data) {
    state.savitarnaKrepselisUrl = data
  },
  savitarnaHomeUrl(state, data) {
    state.savitarnaHomeUrl = data
  },
  savitarnaBreadcrumbs(state, data) {
    state.savitarnaBreadcrumbs = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
